import React from "react";
import "./FilterConfirmation.css";
export default function FilterConfirmation(props) {
  const { mainText1, mainText1Data, mainText2, mainText2Data } = props;
  console.log(props, "check here now");
  return (
    <>
      {(mainText1Data.length !== 0 && mainText1 !== undefined) ||
      (mainText2Data.length !== 0 && mainText2 !== undefined) ? (
        <div style={{ fontFamily: "VoltePlay-Medium" }}>
          <div
            className="confirmationContainer"
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <span className="packs-img">
              {localStorage.getItem("userName").toString()?.substr(1, 2)}
            </span>{" "}
            <span
              className="confirmation-text"
              style={{
                maxWidth: "97%",
                display: "flex",
                flexDirection: "column",
                paddingBottom: "-10%",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginTop: "1%",
              }}
            >
              {mainText1 && mainText1Data.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{mainText1}</h4>
                  <div className="messageDataContainer">
                    {mainText1Data.length !== 0 ? (
                      mainText1Data.map((oneData) => (
                        <p>
                          {props.from !== "A58" ? oneData.name : oneData}{" "}
                          {props.from !== "A58" ? ":" : null}{" "}
                          {props.from !== "A58" ? oneData.description : null}
                        </p>
                      ))
                    ) : (
                      <p>None</p>
                    )}{" "}
                  </div>
                </div>
              ) : null}
              {mainText2 && mainText2Data.length !== 0 ? (
                <div>
                  <h4 style={{ fontWeight: "600" }}>{mainText2}</h4>
                  <div className="messageDataContainer">
                    {mainText2Data.map((oneData) => (
                      <p>
                        {props.from !== "A58" ? oneData.name : oneData}{" "}
                        {props.from !== "A58" ? ":" : null}{" "}
                        {props.from !== "A58" ? oneData.description : null}
                      </p>
                    ))}{" "}
                  </div>
                </div>
              ) : null}
            </span>
          </div>
        </div>
      ) : null}
    </>
  );
}
